/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Event_Management26Inputs */

const en__field_enum_csjensblank_event_management26 = /** @type {(inputs: _Field_Enum_Csjensblank_Event_Management26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event, Tourism or Hospitality Management`)
};

const de__field_enum_csjensblank_event_management26 = /** @type {(inputs: _Field_Enum_Csjensblank_Event_Management26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-, Tourismus- & Gastgewerbe-Management`)
};

/**
* | output |
* | --- |
* | "Event, Tourism or Hospitality Management" |
*
* @param {_Field_Enum_Csjensblank_Event_Management26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_event_management26 = /** @type {((inputs?: _Field_Enum_Csjensblank_Event_Management26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Event_Management26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_event_management26(inputs)
	return de__field_enum_csjensblank_event_management26(inputs)
});
export { _field_enum_csjensblank_event_management26 as "_field_enum_CSJENSBLANK_EVENT_MANAGEMENT" }